export default __webpack_public_path__ + "static/media/blank.784880ae.webp";